module.exports = __webpack_public_path__ + "static/img/bg-ar.0dd9c9c0.webp";